enum BookingProgressCategory {
  REQUESTED = 1,
  BEING_HANDLED = 2,
  HANDLED = 3,
}

export default BookingProgressCategory;